import {ENV} from "@environments/environment";
import {axiosRequest} from '@src/helpers';
import React, {useEffect, useState} from 'react';

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY} = ENV

const TA = () => {


  const getFile = async (code) => await axiosRequest(`${API_URL}/order/${code}/transaction-certificate`, {
    method: 'GET'
  });

  useEffect(() => {
    let location = window.location;
    let url = location.pathname + location.search;
    let code = url ? url.split('/')[2] : location.search.slice(2);
    const getURL = async () => {
      const {data} = await getFile(code);
      window.open(data, "_self");
    };
    getURL();
  }, []);

  return (
    <>
    </>
  );
}

export default TA;
